import {
  STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_BEGIN,
} from '../constants'

export function repeatTakingCarRequest(requestsId, takingCarId) {
  return async (dispatch) => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_REPEAT_REQUEST_BEGIN,
      data: { requestsId, takingCarId }
    })
  }
}
